<template>
  <multiselect 
    placeholder="Select Group"
    :options="groups.data" 
    label="name" 
    track-by="id" 
    :value="selected" 
    @input="handleInput" @remove="handleRemove" />
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'GroupSelect',

  components: {
    Multiselect
  },

  created () {
    this.getGroups()
  },

  props: ['value', 'type'],

  computed: {
    selected () {
      return this.groups.data.find(group => group.id === this.value)
    },

    groupType () {
      return this.type + '-groups'
    }
  },

  data () {
    return {
      groups: {
        data: []
      }
    }
  },

  methods: {
    async getGroups () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/${this.groupType}`)
        this.groups = data.groups
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    handleInput (value) {
      this.$emit('input', value.id)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>